import { render, staticRenderFns } from "./HospitalNewspaper.vue?vue&type=template&id=bac0f7ec&scoped=true"
import script from "./HospitalNewspaper.vue?vue&type=script&lang=js"
export * from "./HospitalNewspaper.vue?vue&type=script&lang=js"
import style0 from "./HospitalNewspaper.vue?vue&type=style&index=0&id=bac0f7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_4o2rd25vzlqqqsloupejyolan4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac0f7ec",
  null
  
)

export default component.exports